module.exports = __webpack_public_path__ + "static/img/barra_6.21ccb22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_6.png
// module id = zgkP
// module chunks = 1